export default "__VITE_ASSET__33d175d7__"